// import React, { useEffect, useState } from 'react';
// import { Helmet } from 'react-helmet';
// import Footer from 'components/Footer';
// import ResponsiveTopNavigation from 'components/navigation/ResponsiveTopNavigation';
// import ServiceModeToggle from 'components/navigation/ServiceModeToggle';
// import ContentFilterTabs from 'components/navigation/ContentFilterTabs';
// import SearchBar from '../components/SearchBar';
// import { useSearchParams } from 'react-router-dom';
// import Image from '../../../components/AppImage';
// import Icon from '../../../components/AppIcon';

// const PopularRestaurant = () => {

//     const [searchParams] = useSearchParams();
// const filter = searchParams.get('filter');

// useEffect(() => {
//   if (filter === "popular") {
//     console.log("اعرض الاكثر شعبية");
//   }

//   if (filter === "rated") {
//     console.log("اعرض الاعلى تقييما");
//   }

//   if (filter === "discounts") {
//     console.log("اعرض الخصومات");
//   }

// }, [filter]);

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);
//    const [favorites, setFavorites] = useState([
//       {
//         id: 1, type: 'restaurant', name: 'اسم المطعم', description: 'اقل سعر اضمن 30000 د.س رس',
//         location: 'الضاحية، الضواحي الكامل', status: '11:31-4', rating: 4.5, reviews: 40,
//         deliveryTime: '40-30 دقيقة', hours: '8:00-21:00', image: '/assets/images/logo.jpeg',
//         imageAlt: 'Restaurant logo with red and white branding',
//         discounts: [
//           { text: 'خصم 20% على أول طلب', color: 'red' },
//           { text: 'خصم 20% على أول طلب', color: 'red' },
//           { text: 'خصم 20% على أول طلب', color: 'red' }
//         ]
//       },
//       {
//         id: 2, type: 'restaurant', name: 'اسم المطعم', description: 'اقل سعر اضمن 30000 د.س رس',
//         location: 'الضاحية، الضواحي الكامل', status: '11:31-4', rating: 4.5, reviews: 40,
//         deliveryTime: '40-30 دقيقة', hours: '8:00-21:00', image: '/assets/images/logo.jpeg',
//         imageAlt: 'Restaurant logo with red and white branding',
//         discounts: [
//           { text: 'خصم 20% على أول طلب', color: 'red' },
//           { text: 'خصم 20% على أول طلب', color: 'red' },
//           { text: 'خصم 20% على أول طلب', color: 'red' }
//         ]
//       },
//       {
//         id: 3, type: 'market', name: 'اسم الماركت', description: 'اقل سعر اضمن 30000 د.س رس',
//         location: 'الضاحية، الضواحي الكامل', status: '11:31-4', rating: 4.5, reviews: 40,
//         deliveryTime: '40-30 دقيقة', hours: '8:00-21:00', image: '/assets/images/logo.jpeg',
//         imageAlt: 'Market logo with branding',
//         discounts: [{ text: 'خصم 20% على أول طلب', color: 'green' }]
//       },
//       {
//         id: 4, type: 'market', name: 'اسم الماركت', description: 'اقل سعر اضمن 30000 د.س رس',
//         location: 'الضاحية، الضواحي الكامل', status: '11:31-4', rating: 4.5, reviews: 40,
//         deliveryTime: '40-30 دقيقة', hours: '8:00-21:00', image: '/assets/images/logo.jpeg',
//         imageAlt: 'Market logo with branding',
//         discounts: [{ text: 'خصم 20% على أول طلب', color: 'green' }]
//       }
//     ]);
//   const restaurantItems = favorites?.filter((item) => item?.type === 'restaurant');

//   return (
//     <>
//       <Helmet>
//         <meta name="description" content="اطلب أشهى الأطباق من أفضل المطاعم مع خدمة التوصيل السريع" />
//       </Helmet>

//       <div className="min-h-screen bg-white smooth-scroll">
//         <ResponsiveTopNavigation />

//         <main className="pt-16">
//           {/* <LocationHeader /> */}
//           <div className="flex flex-col lg:flex-row lg:items-center mt-2">
//             <div className="lg:w-[30%]">
//               <ServiceModeToggle />
//             </div>

//             <div className="lg:flex-1">
//               <SearchBar />
//             </div>
//           </div>
//           <ContentFilterTabs />

//             <div className="max-w-4xl mx-auto px-4 py-6">
//           <div className="space-y-3 md:space-y-4 ">
//                     {restaurantItems?.map((item) =>
//                       <div key={item?.id} className="bg-white rounded-2xl overflow-hidden shadow-sm">
//                         <div className="p-3 md:p-4 flex gap-3 md:gap-4">
//                           <div className="relative flex-shrink-0">
//                             <div className="w-16 h-16 md:w-24 md:h-24 rounded-xl overflow-hidden">
//                               <Image src={item?.image} alt={item?.imageAlt} className="w-full h-full object-cover" />
//                             </div>
//                             <button onClick={() => handleUnfavorite(item?.id)}
//                               className="absolute -top-2 -right-2 w-7 h-7 md:w-8 md:h-8 bg-white rounded-full shadow-md flex items-center justify-center hover:scale-110 transition-transform">
//                               <Icon name="Heart" size={14} color="#FF4500" fill="#FF4500" />
//                             </button>
//                           </div>

//                           <div className="flex-1">
//                             <div className="mb-2 md:mb-3">
//                               <p className="text-xs md:text-sm text-[#999999] mb-1">مطعم وسط المدينة</p>
//                               <p className="text-sm md:text-base font-bold text-[#333333] mb-2">{item?.description}</p>
//                               <div className="flex items-start gap-1">
//                                 <Icon name="MapPin" size={12} md-size={14} color="#FF4500" className="mt-0.5 flex-shrink-0" />
//                                 <p className="text-xs md:text-sm text-[#666666]">{item?.location}</p>
//                               </div>
//                             </div>

//                             <div className="flex flex-col sm:flex-row gap-1 md:gap-2 flex-wrap">
//                               {item?.discounts?.map((discount, index) =>
//                                 <div key={index}
//                                   className={`flex items-center gap-1 md:gap-2 px-2 md:px-3 py-1 md:py-2 rounded-lg ${discount?.color === 'red' ? 'bg-[#FF4500]' : 'bg-[#4CAF50]'} text-white`}>
//                                   <img src="/assets/images/lo.svg" alt="خصم" className="w-3 h-3 md:w-4 md:h-4 object-contain" />
//                                   <span className="text-[9px] md:text-xs font-bold">{discount?.text}</span>
//                                 </div>
//                               )}
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     )}





//                   </div>
//                   </div>



//           <Footer />
//         </main>
//       </div>
//     </>
//   );
// };

// export default PopularRestaurant;
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import Footer from 'components/Footer';
import ResponsiveTopNavigation from 'components/navigation/ResponsiveTopNavigation';
import ServiceModeToggle from 'components/navigation/ServiceModeToggle';
import ContentFilterTabs from 'pages/restaurant-details/components/ContentFilterTabs';
import SearchBar from '../components/SearchBar';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import { base_url } from 'Backend/api';
import AppSpinner from 'components/ui/AppSpinner';
import NoRestaurantScreen from 'pages/NoRestaurantScreen';
import toast from 'react-hot-toast';

const resolveImage = (item) =>
   `${base_url}/storage/app/public/${String(item?.image || "").replace(/^\/+/, "")}`;

const PopularRestaurant = () => {
  const [searchParams] = useSearchParams();
  const filter = searchParams.get('filter') || 'all';
  const category = searchParams.get('category');
  const navigate = useNavigate();
  const [restaurants, setRestaurants] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
  const fetchRestaurants = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");

    if (!token) {
      toast.error("يجب تسجيل الدخول أولاً");
      return;
    }
      let url = `${base_url}/api/restaurants?tab=${filter}&search=${search}`;

      if (category) {
        url = `${base_url}/api/restaurant/categories/${category}/restaurants`;
      }

      // هنا حطينا التوكن
      const response = await fetch(url, {
        method: 'GET',
        headers: {
           Authorization: `Bearer ${token}`,
          'Accept': 'application/json',
        },
      });

      const data = await response.json();

      if (data.status) {
        setRestaurants(data.data || []);
      } else {
        setRestaurants([]);
      }
    } catch (error) {
      console.error("خطأ في جلب المطاعم:", error);
      setRestaurants([]);
    } finally {
      setLoading(false);
    }
  };

  fetchRestaurants();
}, [filter, search, category]);

  const handleUnfavorite = (id) => {
    setRestaurants(prev =>
      prev.map(r => r.id === id ? { ...r, is_favorite: !r.is_favorite } : r)
    );
  };

 

  return (
    <>
      <Helmet>
        <meta name="description" content="اطلب أشهى الأطباق من أفضل المطاعم مع خدمة التوصيل السريع" />
      </Helmet>

      <div className="min-h-screen bg-[#f8f8f8] smooth-scroll">
        <ResponsiveTopNavigation />

        <main className="pt-16">
          <div className="flex flex-col lg:flex-row lg:items-center mt-2">
            <div className="lg:w-[30%]">
              <ServiceModeToggle />
            </div>
            <div className="lg:flex-1">
              <SearchBar onSearch={setSearch} />
            </div>
          </div>

          <ContentFilterTabs />

          <div className="max-w-4xl mx-auto px-4 py-2 font-[cairo]">
            {loading ? (
              <div className="fixed inset-0 bg-black/30 backdrop-blur-sm flex items-center justify-center z-50">
                <AppSpinner />
              </div>
            ) : restaurants.length === 0 ? (
  <NoRestaurantScreen compact />
) : (
              
              <div className="space-y-1 md:space-y-1">
                {restaurants.map(item => (
                  <div
                    dir='ltr'
                    onClick={() => navigate(`/restaurant/${item.slug || item.id}`)}
                    key={item.id}
                    className="bg-white rounded-[6px] border border-[#ECECEC] overflow-hidden cursor-pointer p-3"
                  >
                    <div className="flex gap-3">
                      <div className="w-[76px] shrink-0 text-[12px]">
                        <div className="inline-flex items-center gap-1 rounded-full bg-[#00B200] px-2 py-0.225 text-white">
                          <span>{item?.rating?.average ?? "0.0"}</span>
                          <span>({item?.rating?.reviews_count ?? 0})</span>
                          <Icon name="Star" size={11} color="#FFCF33" fill="#FFCF33" />
                        </div>
                        <div className="mt-2 text-[#00A651] flex flex-col items-start gap-1" dir="ltr">
                          <span dir='rtl' className='text-[#F93209]'>{item?.delivery?.estimate_minutes ?? "—"} دقيقة</span>
                          <div dir='rtl' className="flex items-center gap-1">
                            <img src="/assets/images/bbagg.svg" className="h-3 w-3" alt="" />
                            <span>{item?.delivered_orders_count ?? 0} طلب</span>
                          </div>
                        </div>
                      </div>

                      <div dir='rtl' className="min-w-55 flex-1">
                        <h3 className="text-[14px] font-medium text-[#1F2937] -mt-1 line-clamp-1 font-[cairo]">{item.name}</h3>
                        <div className="text-[11px] text-[#4B5563] mt-1 line-clamp-1">
                          أقل سعر للطلب {item.minimum_order ?? "—"} ل.س
                        </div>
                        <div className="mt-1 flex items-center gap-1 text-[10px] text-[#6B7280] line-clamp-1">
                          <Icon name="MapPin" size={13} color="#F93209" />
                          {item.full_address}
                        </div>
                      </div>

                      <div className="relative w-[68px] shrink-0 sm:w-[76px]">
                        <div className="h-[68px] w-[68px] overflow-hidden rounded-[6px] sm:h-[76px] sm:w-[76px]">
                          <Image src={resolveImage(item)} alt={item.name} className="w-full h-full object-cover" />
                        </div>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            handleUnfavorite(item.id);
                          }}
                          className="absolute -top-1.5 -right-1.5 flex h-6 w-6 items-center justify-center rounded-full bg-white shadow-md"
                        >
                          <Icon name="Heart" size={13} color={item.is_favorite ? "#F93209" : "#ccc"} fill={item.is_favorite ? "#F93209" : "none"} />
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* <Footer /> */}
        </main>
      </div>
    </>
  );
};

export default PopularRestaurant;